import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Avatar, Box, Button, Chip, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PromptRenderer } from './PromptRenderer';
import { usePromptLibrary } from '../PromptLibraryProvider';
export function PreviewPrompt() {
    var _a;
    const { currentPromptID, prompts, setCurrentPromptID, onSelect } = usePromptLibrary();
    const currentPrompt = prompts.find((prompt) => prompt.id === currentPromptID);
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    if (!currentPrompt) {
        return null;
    }
    return (<Box px="2xl" py="xl" gap="md" flexDirection="column" height="100%">
      <PromptRenderer prompt={currentPrompt}/>

      {currentPrompt.isSystemPrompt ? (<Avatar size="xs" solid appearance="secondary">
          <Falcon icon="book-open"/>
        </Avatar>) : (<UserAvatar title={((_a = currentPrompt.createdByUser) === null || _a === void 0 ? void 0 : _a.name) || deletedUser} size="xs"/>)}

      <Box gap="sm" style={{ flexWrap: 'wrap' }}>
        {currentPrompt.labels.map((label) => (<Chip key={label} label={label}/>))}
      </Box>

      <Box mt="auto" ml="auto" gap="md">
        <Button appearance="secondary" size="small" onClick={() => setCurrentPromptID(undefined)}>
          <Trans comment="Prompt Library - Go back button">Go back</Trans>
        </Button>
        <Button onClick={() => onSelect(currentPrompt)} size="small">
          <Trans comment="Prompt Library - Select prompt button">Select</Trans>
        </Button>
      </Box>
    </Box>);
}
